import React from 'react';
import { Grid, TextField } from '@mui/material';

function TimeInputFields({ startTime, setStartTime, endTime, setEndTime, disableTimeFields }) {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Kommetid"
          type="time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 60, // 1 minut pr. trin
          }}
          fullWidth
          disabled={disableTimeFields}
        />
      </Grid>
    </>
  );
}

export default TimeInputFields;
